var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { API_TIMEOUT, BASE_HEADERS } from "./baseService";
class AuthService {
    constructor() {
        this.controllerName = "auth";
        this.apiTimeOut = API_TIMEOUT;
    }
    get api() {
        var _a;
        if (this._api == null || this.baseUrl == null) {
            this.baseUrl = (_a = window.appEnv) === null || _a === void 0 ? void 0 : _a.baseUrl;
            if (this.baseUrl == null) {
                console.warn("Your REACT_APP_API_BASE_URL is not defined, make sure it is correctly set in .env");
            }
            this._api = axios.create({
                timeout: this.apiTimeOut,
                headers: BASE_HEADERS,
                baseURL: `${this.baseUrl}`,
            });
        }
        return this._api;
    }
    refresh(currentCredentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.post(`/${this.controllerName}/refresh`, undefined, {
                headers: Object.assign(Object.assign({}, BASE_HEADERS), { Authorization: `Bearer ${currentCredentials.refresh_token.token}` }),
            });
            return data;
        });
    }
}
export const authService = new AuthService();
//# sourceMappingURL=authService.js.map